// waterMark.vue
<template>
  <div class="watermark-container">
    <div
      class="watermark-text"
      v-for="index in totalWatermarks"
      :key="index"
      :style="{
        top: calculateTop(index),
        left: calculateLeft(index),
        transform: 'rotate(-20deg)',
      }"
    >
      {{ watermarkText }}
    </div>
  </div>
</template>
 
<script>
export default {
  // props: {
  //   // 外部传入的水印文本
  //   watermarkText: {
  //     type: String,
  //     required: true
  //   }
  // },
  data () {
    return {
      innerWidth: null,
      innerHeight: null
    }
  },
  mounted () {
    this.innerWidth = window.innerWidth
    this.innerHeight = window.innerHeight
    window.addEventListener('resize', this.generateWatermarks)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.generateWatermarks)
  },
  computed: {
    totalWatermarks () {
      const minRows = 10 // 假定至少有3行水印
      const widthCount = Math.ceil(this.innerWidth / 50) 
      const heightCount = Math.max(minRows, Math.ceil(this.innerHeight / 50)) 
      return widthCount * heightCount
    },
    watermarkText() {
      console.log(this.$store.state.user.watermarkContent,'---')
      return this.$store.state.user.watermarkContent;
    }
  },
  methods: {
    // 计算出每个水印的top值
    calculateTop (index) {
      const widthCount = Math.ceil(this.innerWidth / 300) //每个水印之间的间隔
      const row = Math.floor(index / widthCount)
      return row * 160 + 'px'
    },
    // 计算出每个水印的left值
    calculateLeft (index) {
      const widthCount = Math.ceil(this.innerWidth / 300) //每行水印之间的间隔
      return (index % widthCount) * 280 + 'px'
    },
    generateWatermarks () {
      this.innerWidth = window.innerWidth
      this.innerHeight = window.innerHeight
      const watermarkContainer = this.$el.querySelector('.watermark-container')
      if (watermarkContainer) {
        const watermarkTexts = watermarkContainer.querySelectorAll('.watermark-text')
        watermarkTexts.forEach((watermarkText, index) => {
          watermarkText.style.top = this.calculateTop(index)
          watermarkText.style.left = this.calculateLeft(index)
        })
      }
    }
  }
}
</script>
 
<style scoped>


.watermark-container {
  position: fixed;
  top: 70px;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
}
 
.watermark-text {
  position: absolute;
  transform: translate(-50%, -50%) rotate(-90deg); 
  opacity: 0.2;     
  color: #808184;  
  font-size: 16px;  
}
</style>


// WEBPACK FOOTER //
// src/components/waterMark/waterMark.vue